module.exports = __webpack_public_path__ + "frontend/images/pattern/green@2.jpg?6a962ed61a81241c0c7cd053edea09e9";